<div class="modal-box" style="z-index: 9999;">
  <div class="modal-header-custom">
    <h6 class="mb-2 font">Multi Modal Message</h6>
    <div class="mb-0 d-flex gap-3">
      <div class="form-check">
        <input class="form-check-input" type="checkbox" id="illumLive" [(ngModel)]="illumLive" checked>
        <label class="form-check-label font" for="illumLive">Illum Live</label>
      </div>
      <div class="form-check">
        <input class="form-check-input" type="checkbox"  [(ngModel)]="sendSms" id="sms" checked>
        <label class="form-check-label font" for="sms">SMS</label>
      </div>
      <div class="form-check">
        <input class="form-check-input" type="checkbox" id="email" [(ngModel)]="sendEmail" checked>
        <label class="form-check-label font" for="email">Email</label>
      </div>


      <select class="form-select form-select-sm ms-auto"
        style="width: 166px;"
        [(ngModel)]="selectedTemplateId"
        (change)="onTemplateChange()">
        <option value="">Select Template</option>
        @for (template of messageTemplates; track template) {
          <option [value]="template.id">
            {{ template.name || template.label || template.subject || 'Template' }}
          </option>
        }
      </select>
    </div>
  </div>
  <div class="p-3">

    @if (options?.useApi || options?.bulkOrg) {
      <div class="mb-2 text-primary font">
        Recipients: {{options.recipients}}
      </div>
    }
    <!-- Recipients -->
    @if (!options?.useApi && !options?.bulkOrg) {
      <p class="mb-2 text-primary font">
        Recipients:
        <span class="text-muted">(total: {{ selectedUsers.length }})</span>
        <i class="bi bi-person-plus ms-2" style="cursor:pointer;" (click)="showUserList = !showUserList"></i>
      </p>
    }
    <p class="mb-2 text-primary font"> @for (user of selectedUsers; track user) {
      <span class="badge bg-primary me-1 font" style="text-transform: capitalize; font-weight: 300;">
        {{ user.name }}
        <span class="ms-1" style="cursor:pointer;" (click)="removeUser(user)">×</span>
      </span>
    }</p>

    <!-- User search and list, shown only when showUserList is true -->
    @if (showUserList) {
      <div>
        <div class="mb-2">
          <input class="form-control input-bg-color font" placeholder="Search users..." [(ngModel)]="orgTreeSearch" (input)="onSearchInput(orgTreeSearch)" />
        </div>
        <div class="custom-scroll" style="max-height: 200px">
          <table class="table table-hover custom-table">
            <tbody>
              @for (user of filteredUsers; track user) {
                <tr>
                  <td class="userList">
                    <input type="checkbox" [checked]="isSelected(user)" (change)="toggleUser(user)" />
                    {{ user.name }}
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
        <div class="mt-2 pb-2 text-end">
          <button class="btn btn-sm btn-primary" (click)="showUserList = false">Done</button>
        </div>
      </div>
    }


    <!-- Subject -->
    <div class="mb-1">
      <div class="form-section-label font">Subject</div>
    </div>
    <div class="mb-3">
      <input class="form-control input-bg-color font"
        placeholder="Subject"
        [(ngModel)]="subject" />
      </div>
      <!-- Illum Live/SMS Body -->
      @if (sendSms || illumLive) {
        <div class="form-section-label font">
          Body for Illum live and SMS (HTML tags not acknowledged)
          <span class="text-light float-end small">Character Count: 0, limit: 1500</span>
        </div>
      }
      @if (sendSms  || illumLive) {
        <div class="mb-3">
          @if (sendSms || illumLive) {
            <textarea class="form-control input-bg-color font"
              rows="3"
              placeholder="Messages for IllumLive/SMS"
            [(ngModel)]="illumLiveSmsBody"></textarea>
          }
        </div>
      }

      <!-- Email Body -->
      @if (sendEmail) {
        <div class="form-section-label">
          Body (For Email – HTML tags acknowledged)
        </div>
      }
      @if (sendEmail) {
        <div class="mb-3">
          @if (sendEmail) {
            <textarea class="form-control input-bg-color font"
              rows="3"
              placeholder="Messages for Email"
            [(ngModel)]="emailBody"></textarea>
          }
        </div>
      }

      <!-- Upload -->
      <div class="upload-box">
        <div class="upload-icon">📁</div>
        <p>Attachment (images or video file only, max size 20MB)</p>

        <!-- Hidden file input -->
        <input
          type="file"
          id="fileInput"
          accept="image/*,video/*"
          style="display: none"
          (change)="onFileSelected($event)"
          />

          <!-- Trigger button -->
          <button class="btn btn-primary btn-sm" (click)="triggerFileInput()">Add</button>
        </div>

        @if (showErrorMessage) {
          <div class="alert alert-danger mt-2" role="alert">
            {{ errorMessage }}
          </div>
        }

        <!--   Show message -->
        @if (message) {
          <div
            [class.alert-danger]="isError"
            [class.alert-success]="!isError"
            class="alert text-center py-2">
            {{ message }}
          </div>
        }


        <!-- Action Buttons -->
        <div class="d-flex justify-content-end mt-4">
          <button
            type="button"
            class="btn btn-outline-primary btn-space"
            aria-label="Close"
            (click)="activeModal.dismiss('Cross click')"
          >Cancel</button>

          <button class="btn btn-primary" (click)="sendNew()">Send</button>
        </div>
      </div>
    </div>
    @if (isLoading) {
      <div class="loader-overlay">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    }
